import React, { useCallback, useContext, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";

import Config from "@skin_config";
import { POPUPS } from "@common/constants/popups";
import { PopupContext } from "@app/dev/contexts/popup";
import { useTranslation } from "@common/hooks/translation";
import { useBalance } from "@app/dev/terminal/hooks/balance";
import TooltipDropDown from "@common/components/tooltipDropDown";
import OctopayLogo from "@app/dev/images/deposit/octopay-logo.png";
import { DepositModeEnum } from "@app/dev/constants/enums/depositMode";
import { TerminalDepositModesEnum } from "@app/dev/constants/enums/terminalDepositModes";
import { CashoutMoney } from "@app/dev/actions/terminal";
import { getAuthData } from "@common/helpers/auth";
import { isMultiDepositModeEnabled } from "@app/dev/helpers/multiDepositMode";

const CashoutButtonStandard = ({ onClick, showAsDrowpdownHeader = false }) => {
  const t = useTranslation();

  return (
    <div className="cashout" onClick={onClick}>
      <i className="global-icon icon-cashout" />
      <p>{t("Cash out")}</p>
      {showAsDrowpdownHeader && <i className="global-icon icon-thin-arrow-down" />}
    </div>
  );
};

export const CashoutButton = () => {
  const terminalBalance = useBalance();
  const [{ openPopup }] = useContext(PopupContext);
  const { depositMode, loggedIn, loggedInByRFID } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const userLoggedin = loggedInByRFID || loggedIn;
  const { playerInfo, depositMode: terminalDepositMode, verification } = useSelector((state) => state.terminal);

  const openCashoutPopup = useCallback(
    (clearStateBeforeCashout) => {
      if (depositMode === DepositModeEnum.Cash || terminalBalance === 0) {
        if (Config.cashoutMethods.length && userLoggedin) {
          openPopup(POPUPS.CASHOUT_METHODS);
        } else {
          openPopup(POPUPS.CASHOUT, { clearStateBeforeCashout });
        }
      } else openPopup(POPUPS.CASHOUT_BY_BANK_CARD);
    },
    [depositMode, openPopup, terminalBalance, userLoggedin]
  );

  const cashoutOptions = useMemo(() => {
    const authData = getAuthData()

    if (terminalDepositMode === TerminalDepositModesEnum.Ticket && isMultiDepositModeEnabled())
      return [
        {
          buttonName: "Cash out",
          iconName: "icon-cashout",
          callback: () => openCashoutPopup(true),
          enabled: true,
        },
        {
          buttonName: "Okto pay",
          pic: OctopayLogo,
          callback: () => {
            if (playerInfo?.PersonalId) dispatch(CashoutMoney(null));
            else openPopup(POPUPS.CASHOUT_BY_OCTO);
          },
          enabled: true,
        },
      ];

    return [];
  }, [terminalDepositMode, openCashoutPopup, openPopup, playerInfo]);

  const isVerificationDone = !Config.main.hasVerification || verification.isVerified;

  if (
    (loggedIn && Config.disableCashoutAfterLogin) ||
    Config.disableCashoutInHeader ||
    !isVerificationDone ||
    !terminalBalance
  )
    return null;

  if (cashoutOptions.length) {
    return (
      <TooltipDropDown
        className="header-item cashout-options"
        options={cashoutOptions}
        header={<CashoutButtonStandard showAsDrowpdownHeader />}
      />
    );
  }

  return <CashoutButtonStandard onClick={() => openCashoutPopup()} />;
};
